module.exports = __webpack_public_path__ + "img/alert_opened.2ca9702e.svg";